import { useApi } from "../api";
import { createAdminCrudApi } from "../createAdminCrudApi";
import {
  InsertScrewFamilyBody,
  ScrewFamily,
  SearchScrewFamiliesResponse,
  UpdateScrewFamilyBody,
} from "./types/screwFamilies";
import { SCREW_CONNECTOR_ADMIN_URL } from "./screwConnectorAdminUrl";
import { SCREW_CONNECTOR_URL } from "./screwConnectorUrl";

// Visibility and order go through the full update (no /visibility nor /order endpoints).
export const useScrewConnectorScrewFamiliesApi = () => {
  const api = useApi();
  // The calculator reads the screw families too.
  const crud = createAdminCrudApi<SearchScrewFamiliesResponse, InsertScrewFamilyBody, UpdateScrewFamilyBody>(
    api,
    SCREW_CONNECTOR_ADMIN_URL,
    "screw_families",
    [SCREW_CONNECTOR_URL],
  );

  return {
    useScrewFamilies: crud.useSearch,
    getScrewFamilies: crud.search,
    getScrewFamilyById: (id: string, signal: AbortSignal) =>
      api.get<ScrewFamily>({ url: `${SCREW_CONNECTOR_ADMIN_URL}/screw_families/${id}`, signal }),
    insertScrewFamily: crud.insert,
    updateScrewFamily: crud.update,
    deleteScrewFamily: crud.remove,
    uploadImage: crud.uploadImage,
  };
};

export default useScrewConnectorScrewFamiliesApi;
